import React, { useEffect, useMemo, useRef } from 'react';
import { Skeleton } from 'antd';
import dayjs from 'dayjs';
import { ScrollView } from '@/components';
import { ScrollViewRefAttrs } from '@/components/scroll-view';
import RecommendListItem from './RecommendListItem';

import cx from './index.module.scss';

interface Props {
  customerInfo: GetCustomerProfileResponse;
  loading: boolean;
}

const TreatmentCourseRecommend: React.FC<Props> = ({ customerInfo, loading }) => {
  const scrollViewRef = useRef<ScrollViewRefAttrs>(null);
  const lastTreatmentTime = useMemo(() => {
    const inputDate = dayjs(customerInfo?.treatmentTime, 'YYYY/MM/DD');
    const today = dayjs().startOf('day');
    const diff = today?.diff(inputDate, 'day');

    if (diff === 0) {
      return '今天';
    } else if (diff === 1) {
      return '昨天';
    } else if (diff === 2) {
      return '前天';
    } else {
      return inputDate.format('YYYY/MM/DD');
    }
  }, [customerInfo?.treatmentTime]);

  useEffect(() => {
    if (!loading) {
      scrollViewRef.current?.handleRefresh();
    }
  }, [loading]);

  return (
    <div className={cx('recommend-wrapper')}>
      <Skeleton loading={loading} title={false} paragraph={{ rows: 2 }}>
        <div className={cx('info-wrapper')}>
          {/* 从未下单则不显示 */}
          {customerInfo?.treatmentTime !== null && (
            <>
              <div className={cx('header')}>
                <div className={cx('title')}>实际理疗频率</div>
                <div className={cx('time')}>
                  <div>
                    <span>最近理疗时间</span>
                    <span className={cx('value')}>{lastTreatmentTime}</span>
                  </div>
                  <div>
                    <span>，平均</span>
                    <span className={cx('value')}>每周{customerInfo?.treatmentCycle}次</span>
                  </div>
                </div>
              </div>

              <div className={cx('divider', { hide: customerInfo?.treatmentTime === null })} />
            </>
          )}

          <div className={cx('info-item')}>
            <div className={cx('title')}>疗程建议</div>
            <div className={cx('value')}>
              {customerInfo?.treatmentCycleSuggestion ? '保持理疗频率' : '需提高理疗频率'}
              {customerInfo?.recommendGoods?.length > 0 && '，推荐以下方案'}
            </div>
          </div>
        </div>

        <div className={cx('list-wrapper', { show: customerInfo?.recommendGoods?.length > 0 })}>
          <ScrollView className={cx('goods-list-wrapper')} ref={scrollViewRef} scrollbar={{ fade: false }} scrollY>
            <div className={cx('goods-list')}>
              {customerInfo?.recommendGoods?.map(item => (
                <RecommendListItem key={item.id} goodsItem={item} />
              ))}
            </div>
          </ScrollView>
        </div>
      </Skeleton>
    </div>
  );
};

export default TreatmentCourseRecommend;
